import type { IconSvgObject } from './types';

const User02Icon: IconSvgObject = [
  ["path", { d: "M18.5 20V16.9852C18.5 16.364 18.2184 15.7658 17.6838 15.4494C16.1574 14.546 14.1714 14 12 14C9.82863 14 7.84261 14.546 6.31618 15.4494C5.78162 15.7658 5.5 16.364 5.5 16.9852V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "7.5", r: "3.5", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export default User02Icon;
